import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { updateUser, updatePassword } from 'store/actions/user';
import ProfileSettings from 'components/UserProfile/ProfileSettings';

export default withTranslation()(
  connect(null, { updateUser, updatePassword })(ProfileSettings),
);
